import { supabase } from "../lib/supabase";
import { logExtractedEventMutation } from "../lib/productEvents";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

/**
 * @param {{ days?: number }} [params]
 */
export async function fetchScheduleItems({ days = 90 } = {}) {
  const headers = await authHeaders();
  const res = await fetch(
    `${API_BASE}/api/schedule-items?days=${encodeURIComponent(String(days))}`,
    { headers },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Laden fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * @param {{ title: string, date: string, time?: string|null, all_day?: boolean, place?: string|null, action_type?: 'task'|'event', remind?: boolean }} body
 */
export async function createScheduleItem(body) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/schedule-items`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Speichern fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * @param {string} id
 * @param {{ done?: boolean, remind?: boolean, title?: string, date?: string, time?: string|null, all_day?: boolean, place?: string|null, child?: string|null, visibility?: 'mine'|'household' }} body
 */
export async function patchScheduleItem(id, body) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/schedule-items/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Speichern fehlgeschlagen (${res.status}).`);
  }
  // Fire-and-forget accuracy signal for mail/capture-sourced items (date/time/title/child).
  logExtractedEventMutation({ item: data?.item, body });
  return data;
}
